import { Button, Modal } from "@xola/ui-kit";
import { noop } from "lodash";
import React from "react";
import { useAccountStore } from "../../stores/accountStore";

export const SessionExpiredModal = () => {
    const isSessionExpiredModalVisible = useAccountStore((state) => state.isSessionExpiredModalVisible);
    const goToLogin = useAccountStore((state) => state.forget);

    return (
        <Modal isOpen={isSessionExpiredModalVisible} shouldCloseOnOutsideClick={false} onClose={noop}>
            <Modal.Header>You&apos;ve Been Logged Out</Modal.Header>
            <Modal.Body>
                <p>
                    You were logged out because you signed out in another tab or your password was reset. Please log in
                    again.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={goToLogin}>Log In</Button>
            </Modal.Footer>
        </Modal>
    );
};
